import React from 'react';
import TextSpanPortal from './TextSpanPortal'

/*
immunoNoBeds
immunoWithBed
severeNoBeds
severeWithBeds
*/

const DeathRates = ({deathRates}) => {
  return (
    <svg>
      <TextSpanPortal portalId="healthy-has-bed-deaths">{Math.round((1 - deathRates.severeWithBeds) * 100)}</TextSpanPortal>
      <TextSpanPortal portalId="healthy-has-bed-recovers">{Math.round((deathRates.severeWithBeds) * 100)}</TextSpanPortal>
      <TextSpanPortal portalId="healthy-no-bed-deaths">{Math.round((1 - deathRates.severeNoBeds) * 100)}</TextSpanPortal>
      <TextSpanPortal portalId="healthy-no-bed-recovers">{Math.round((deathRates.severeNoBeds) * 100)}</TextSpanPortal>
      <TextSpanPortal portalId="immuno-has-bed-deaths">{Math.round((1 - deathRates.immunoWithBed) * 100)}</TextSpanPortal>
      <TextSpanPortal portalId="immuno-has-bed-recovers">{Math.round((deathRates.immunoWithBed) * 100)}</TextSpanPortal>
      <TextSpanPortal portalId="immuno-no-bed-deaths">{Math.round((1 - deathRates.immunoNoBeds) * 100)}</TextSpanPortal>
      <TextSpanPortal portalId="immuno-no-bed-recovers">{Math.round((deathRates.immunoNoBeds) * 100)}</TextSpanPortal>
    </svg>
  );
};


export default DeathRates;